import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import en from "./utils/language/en";
import zh from "./utils/language/zh";
import VueI18n from "vue-i18n";
import ElementLocale from "element-ui/lib/locale";
import enLocale from "element-ui/lib/locale/lang/en"; // 引入el自带得国际化语言包,防止内部插件出现乱码
import zhLocale from "element-ui/lib/locale/lang/zh-CN"; // 引入el自带得国际化语言包,防止内部插件出现乱码
var allZhLocale = Object.assign(zhLocale, zh);
var allEnLocale = Object.assign(enLocale, en);

Vue.use(VueI18n);

// 创建实例对象
const i18n = new VueI18n({
  messages: {
    zh: allZhLocale, // 中文语言包
    en: allEnLocale, // 英文语言包
  },
  locale: navigator.language,
  silentFallbackWarn: true,
});

ElementLocale.i18n((key, value) => i18n.t(key, value));
export default i18n;

Vue.config.productionTip = false;

// 按需引入 element-ui 组件
import "element-ui/lib/theme-chalk/index.css";
import elementComponents from "@/common/register-element-components";
Vue.use(elementComponents);

import "@/styles/overwirteElement.less";
import "@/styles/main.less";
import "animate.css";
import { getDicts } from "@/api/dict/data";
import { selectDictLabel, selectDictLabels } from "@/utils/ruoyi";

// 字典数据组件
import DictData from "@/components/DictData";
// 字典标签组件
import DictTag from "@/components/DictTag";

/*// 动画库
import animated from "animate.css";
Vue.use(animated);*/

// 全局方法挂载
Vue.prototype.getDicts = getDicts;
Vue.prototype.selectDictLabel = selectDictLabel;
Vue.prototype.selectDictLabels = selectDictLabels;

// 全局组件注册
Vue.component("DictTag", DictTag);
import globalComponents from "@/common/register-components";
Vue.use(globalComponents);

DictData.install();

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
